import { DialogProps, default as MuiDialog } from '@mui/material/Dialog'
import * as React from 'react'

const Dialog: React.FC<React.PropsWithChildren<DialogProps>> = (props) => {
  return <MuiDialog {...props} />
}

export default Dialog
